import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { WHITE_COLOR, BLUE_COLOR } from '../../../constants/ColorsConst';
import { dateformat } from '../../../helpers';
import dayjs from 'dayjs';

const BotonFechasComponent = ({ futuro, dateRango, setIsRango }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const options = [
    'Hoy',
    '3 Días',
    '1 Semana',
    '15 Días',
    '1 Mes',
    '2 Meses',
    '3 Meses',
    'Personalizado',
  ];

  const dias = [
    dateformat(null, { full: true }),
    dayjs().add(2, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(7, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(15, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(30, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(60, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(90, 'day').format('YYYY-MM-DD HH:mm:ss'),
    null,
  ];

  const diasPasados = [
    dateformat(null, { full: true }),
    dayjs().add(-2, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(-7, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(-15, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(-30, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(-60, 'day').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().add(-90, 'day').format('YYYY-MM-DD HH:mm:ss'),
    null,
  ];

  const date = dias[0];

  React.useEffect(() => {
    dateRango(
      futuro ? date : diasPasados[selectedIndex],
      futuro ? dias[selectedIndex] : date,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [futuro]);

  const handleMenuItemClick = (_, index) => {
    setSelectedIndex(index);
    setOpen(false);
    setIsRango(futuro ? dias[index] === null : diasPasados[index] === null);
    if (index === options.length - 1) return;
    dateRango(futuro ? date : diasPasados[index], futuro ? dias[index] : date);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  return (
    <React.Fragment>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="split button"
      >
        <Button
          sx={{
            backgroundColor: BLUE_COLOR,
            color: WHITE_COLOR,
            borderRight: `1px solid ${WHITE_COLOR} !important`,
            borderColor: BLUE_COLOR,
            '&:hover': {
              backgroundColor: BLUE_COLOR,
            },
            '&:active': {
              backgroundColor: BLUE_COLOR,
            },
          }}
          onClick={() => false}
        >
          {options[selectedIndex]}
        </Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
          sx={{
            backgroundColor: BLUE_COLOR,
            color: WHITE_COLOR,
            '&:hover': {
              backgroundColor: BLUE_COLOR,
            },
            '&:active': {
              backgroundColor: BLUE_COLOR,
            },
          }}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 999,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      // disabled={index === 2}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
};

export default BotonFechasComponent;
